import { StepPage } from 'directFlow/types'

export const isPageInFormProgress = (page: StepPage, formProgress: StepPage[]) =>
  formProgress.includes(page)
